<template lang="pug">
  div
    h3.text-primary.pt-2.pb-4 Objects Management
    template(v-for='(item, index) in project.project_structures')
      c-structure-customers(
        :item='item'
      )

</template>

<script>
  import server from '@/server'
  import Policeman from '@/utils/Policeman/policeman'
  import cStructureCustomers from '@/components/Project/StructureCustomers'
  import RouteGen from '@/utils/apiRoutes'

  export default {
    name: 'StructuresManagement',
    components: { cStructureCustomers },
    data () {
      return {
        project: {
          // project_structures: [
          //   {
          //     id: null,
          //     structure: {},
          //     customers: []
          //   }
          // ]
        }
      }
    },
    mounted () {
      this.fetchProject(this.$route.params.id)
    },
    methods: {
      fetchProject (projectId) {
        let currentPermissions = this.$route.meta.roles
        if (!Policeman.authorize(currentPermissions)) {
          this.showNotification(401)
          this.$route.push({ name: 'Home' })
        }
        let route = RouteGen.show('project', projectId)
        server.get(route)
          .then(res => {
            let project = res.data.project
            this.$set(this.$data, 'project', project)
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Project/StructuresManagement.vue